import React from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { useTheme } from '@mui/material/styles'

import { useItemTooltip } from '@mui/x-charts/ChartsTooltip'

import { Text } from '@mxenabled/mxui'

import { CategoryIconLabel } from './CategoryIconLabel'
import { CurrencyText } from '../../CurrencyText'
import { DATE_FORMATS_INTL, formatDate } from '../../../../core/constants'

interface CustomPointTooltipProps {
  categoryGuids: { guid: string; topLevelGuid: string }
  series: Array<{ id: string; data: number[] }>
  xData: Date[]
}

// Custom tooltip for hovering on line points
export const CustomPointTooltip: React.FC<CustomPointTooltipProps> = ({
  categoryGuids: { guid, topLevelGuid },
  series: allSeries,
  xData,
}) => {
  const tooltip = useItemTooltip()
  const theme = useTheme()

  if (!tooltip?.identifier) return null

  const { dataIndex, seriesId } = tooltip.identifier
  if (dataIndex == null || !seriesId) return null

  const seriesData = allSeries.find((s) => s.id === seriesId)
  const dataValue = seriesData?.data?.[dataIndex]
  const dataDate = xData?.[dataIndex]

  if (dataValue === undefined || !dataDate) return null

  return (
    <Card sx={{ pt: 4, px: 8 }}>
      <CardContent>
        <Box alignItems="center" display="flex" flexDirection="column">
          <CategoryIconLabel categoryGuid={guid} topLevelCategoryGuid={topLevelGuid} />
          <Text color={theme.palette.text.secondary} variant="body2">
            {formatDate(dataDate, DATE_FORMATS_INTL.MONTH_SHORT_YEAR)}
          </Text>
          <CurrencyText amount={String(dataValue)} bold={true} formatString="0,0" variant="body1" />
        </Box>
      </CardContent>
    </Card>
  )
}
